
import moment from 'moment';
import * as arcService from '@/services/arc-api.service'
import vuei18n from '@/plugins/vue-i18n';
export default {
    sponsorFormFields: (state) => state.newAuthorization.sponsorForm,
    sponsorFormMethod: (state) => state.newAuthorization.beneficiarySearch.formSlug,
    authorizations: (state) => {
        return state.authorizations.map(authorization => {
            return {
                code: authorization.id,
                createdAt: moment(authorization.createdAt).format('DD/MM/YYYY HH:mm'),
                sponsor: authorization.sponsorName,
                beneficiary: authorization.beneficiaryName,
                memberCode: authorization.beneficiaryMemberCode,
                authorizationType: vuei18n.t(arcService.getType(authorization.transactionType)),
                status: vuei18n.t(arcService.getStatus(authorization))
            }
        })
    },
    loadingAuthorizations: (state) => state.loadingAuthorizations,
    authorizationPage: (state) => {
        const { page } = state;
        return { ...page, number: page.number + 1 }
    },
    beneficiaries: (state) => {
        if(state.beneficiaries.content){
            return state.beneficiaries.content.map(beneficiary => {
                return {
                    name: beneficiary.name.toLowerCase(),
                    birth: moment(beneficiary.dateOfBirth).format('DD/MM/YYYY'),
                    identification: beneficiary.identityDocumentId,
                    owner: beneficiary.owner,
                    sex: beneficiary.sex === 'MALE' ? 'beneficiaryResults.male' : 'beneficiaryResults.female',
                    id: beneficiary.id,
                    age: beneficiary.age,
                    status: beneficiary.status
                }
            })
        }else{
            return []
        }
    },
    beneficiariesTotalResults: (state) => state.beneficiaries.page ? state.beneficiaries.page.totalElements : 0,
    isTypeSelected: (state) => state.newAuthorization.steps.type,
    isSponsorSelected: (state) => state.newAuthorization.steps.sponsor,
    isMethodSelected: (state) => state.newAuthorization.steps.method,
    isBeneficiarySelected: (state) => state.newAuthorization.steps.beneficiary,
    isBeneficiarySearchComplete: (state) => state.newAuthorization.steps.beneficiarySearchComplete,
    beneficiary: (state) => state.beneficiary,
    beneficiaryError: (state) => state.beneficiaryError,
    beneficiarySelected: (state) => state.beneficiarySelected,
    beneficiarySearchError: (state) => state.errorAlert,
    outpatientCareForm: (state) => state.outpatientCareForm,
    isBiometricVerified: (state) => state.outpatientCareForm.isVerified,
    loadingVerification: (state) => state.loadingVerification,
    authorizationTypeSelected: (state) => state.newAuthorization.type,
    navBarType: (state) => state.newAuthorization.navBarType,
    authorizationResult: (state) => state.authorizationResult,
    loadingCreateClaim: (state) => state.loadingCreateClaim
}